import styles from './illustrasjon.module.css'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function hydrate(el, props) {
  const illustrasjon = el.querySelector(`.${styles.illustrasjon}`)
  const path = el.querySelector(`.${styles.animatePath}, .${styles.animatePathReverse}`)
  const length = path?.getTotalLength()
  if (length) {
    path.style.setProperty('--_path-length', length)
    path.style.setProperty('--_path-length2x', 2 * length)
  }

  if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    /*
    Mark svgs as visible once they are in the viewport.

    If the svg contains an animation element that has not been started animated[begin="indefinite"]
    we start it.
    */
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if (entry.target.classList.contains(styles.visible)) {
              continue
            }
            entry.target.classList.add(styles.visible)

            /* Start all waiting animations */
            for (const animate of entry.target.querySelectorAll('animate[begin="indefinite"]')) {
              animate.beginElement()
            }
            observer.disconnect()
          }
        }
      },
      {
        threshold: 0.5,
        rootMargin: '-10% 0px -30% 0px',
      }
    )
    observer.observe(illustrasjon)
  }

  /*
  Update the viewbox of the svg to make it responsive
  Uses the following attributes
  - data-viewbox-mobile
  - data-viewbox-desktop
  */
  let currentView = 'desktop'
  const updateSvgView = () => {
    const isDesktop = window.matchMedia('(min-width: 720px)').matches
    const responsiveSvg = el.querySelector('svg[data-viewbox-desktop][data-viewbox-mobile]')
    const nextView = isDesktop ? 'desktop' : 'mobile'
    if (!responsiveSvg || nextView === currentView) {
      return
    }

    const viewbox = responsiveSvg.getAttribute(`data-viewbox-${nextView}`)
    responsiveSvg.setAttribute('viewBox', viewbox)
    currentView = nextView
  }
  window.addEventListener('resize', updateSvgView)
  updateSvgView()
}
